import axios from './axios';
import { getFromS3, uploadToS3 } from './files';

export const getFieldsValidations = ({ page, name, fieldType, count }) =>
    axios.get('/customvalidations/v1', {
        params: { page, name, fieldType },
        headers: { count },
    });

export const getFieldValidation = (id) =>
    axios.get(`/customvalidations/v1/${id}`).then(({ data }) => {
        if (data) return getFromS3(data.linkToCode).then(({ data: code }) => ({ ...data, code }));
        throw new Error('No file Uploaded');
    });

export const createFieldValidation = (data, file) =>
    axios.post(`/customvalidations/v1`, data).then(({ data }) => {
        if (data) return uploadToS3(data.linkToUpload, file).then(() => data);
        throw new Error('No file Uploaded');
    });

export const updateFieldValidation = (id, data, file) =>
    axios.put(`/customvalidations/v1/${id}`, data).then(({ data }) => {
        if (data) return uploadToS3(data.linkToUpload, file).then(() => data);
        throw new Error('No file Uploaded');
    });

export const deleteFieldValidation = (id) => axios.delete(`/customvalidations/v1/${id}`);
